export const URL="https://www.mycheckers.online"
export const URL_myparams=URL+'/myparams'
export const URL_img=''
export const URL_flags=URL_img+'/flags'
export const URL_newuser=URL+'/newuser'
export const URL_forgotpass=URL+'/forgotpass'
export const URL_changepass=URL+'/changepass'
export const URL_activation=URL+'/activation'